import { CalendarRange } from "lucide-react";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "./ui/select";

// Unified month/archive selector used across all monthly reports.
// Reports default to the CURRENT calendar month (KSA) and keep past months reachable here.
const AR_MONTHS = ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو",
  "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"];

export const monthLabel = (ym) => {
  if (!ym) return "";
  const [y, m] = String(ym).split("-").map(Number);
  return `${AR_MONTHS[(m || 1) - 1]} ${y}`;
};

// Current calendar month in KSA time (UTC+3), as "YYYY-MM".
export const ksaMonth = () => new Date(Date.now() + 3 * 3600000).toISOString().slice(0, 7);

export const MonthArchiveBar = ({ months = [], value, onChange, className = "" }) => {
  const cur = ksaMonth();
  const opts = Array.from(new Set([cur, ...(months || [])])).sort().reverse();
  const val = value || cur;
  const isArchive = val !== cur;
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="month-archive-bar" dir="rtl">
      <CalendarRange className="h-4 w-4 text-slate-400 shrink-0" />
      <Select value={val} onValueChange={(v) => onChange?.(v)}>
        <SelectTrigger className="h-9 w-[190px] text-sm font-semibold" data-testid="month-archive-select">
          <SelectValue />
        </SelectTrigger>
        <SelectContent dir="rtl" className="max-h-72">
          {opts.map((m) => (
            <SelectItem key={m} value={m} data-testid={`month-opt-${m}`}>
              {monthLabel(m)}{m === cur ? " (الحالي)" : ""}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {isArchive && (
        <span className="text-[11px] rounded-full bg-amber-100 text-amber-700 px-2 py-0.5 border border-amber-200 shrink-0">
          أرشيف
        </span>
      )}
    </div>
  );
};
